import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";
import { site } from "@/content/site";
import { SEO } from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { PhotoFrame } from "@/components/PhotoFrame";

export default function About() {
  return (
    <>
      <SEO
        title="About | EVE — Modern Rock Band from Surabaya"
        description="Meet EVE, a modern rock band from Surabaya, Indonesia. More than music — it's an experience of powerful melodies, explosive energy and unforgettable live shows."
      />
      <section data-testid="about-page" className="pb-24 pt-24 lg:pt-28">
        <Reveal>
          <div className="container-eve">
            <div className="border border-white/10 bg-eve-deep p-2 sm:p-3">
              <PhotoFrame
                src={site.photos.about.path}
                alt={site.photos.about.alt}
                eager
                testId="about-band-photo"
                className="h-[62vh] w-full sm:h-[78vh]"
                imgClassName="grayscale-[0.15]"
                label="OFFICIAL BAND PHOTO PENDING"
              />
            </div>
          </div>
        </Reveal>

        <div className="container-eve pt-16 lg:pt-24">
          <Reveal>
            <p className="eyebrow mb-8">
              About the band — {site.band.genre} · {site.band.origin}
            </p>
            <h1 className="font-display uppercase leading-[0.98]">
              <span className="block text-4xl sm:text-5xl lg:text-7xl">We are EVE.</span>
              <span className="block text-4xl sm:text-5xl lg:text-7xl">More than music.</span>
              <span className="block text-4xl sm:text-5xl lg:text-7xl">
                It&apos;s an <span className="gradient-text">experience.</span>
              </span>
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-12 max-w-4xl text-xl leading-relaxed text-eve-ink/85 sm:text-2xl lg:text-[1.7rem] lg:leading-snug">
              {site.band.description}
            </p>
            <div className="mt-12 flex flex-col gap-4 sm:flex-row">
              <Link to="/music" data-testid="about-explore-music-btn" className="btn-primary">
                Explore our music <ArrowRight size={14} />
              </Link>
              <Link to="/video" data-testid="about-watch-live-btn" className="btn-outline">
                Watch EVE live <Play size={14} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
